import {useEffect, useRef, useState} from "react";
import {normalizeImgUrlToThumb} from "../../utils/Helper";

export function Events({title,description,events}){

    return (
        <section
            className="p-0 bg-black border-bottom border-color-transparent-white-very-light background-position-left-bottom background-no-repeat overflow-hidden"
            style={{backgroundImage: "url('/benefitshare/img/demo-conference-schedule-bg.png')"}}>
            <div className="container-fluid">
                <div className="row justify-content-center"
                     data-anime={JSON.stringify({
                         "el": "childs",
                         "translateX": [50, 0],
                         "opacity": [0, 1],
                         "duration": 1200,
                         "delay": 0,
                         "staggervalue": 150,
                         "easing": "easeOutQuad"
                     })}>
                <EventHeaderBox title={title} description={description}></EventHeaderBox>
                    {events.map((event,idx)=>{
                        return <EventFeatureBox key={idx} idx={idx} title={event.title} presentations={event.presentations}></EventFeatureBox>
                    })}

                </div>
            </div>
        </section>
    )
}

export function EventFeatureBox({idx,title,presentations}){

    return(
        <div className="col-xl-3 col-md-4 event-style-01 p-0">
            <div
                className="bg-black hover-box will-change-inherit dark-hover feature-box ps-19 pe-19 pt-22 pb-27 md-p-8 md-pb-25 sm-pb-50px overflow-hidden h-100 text-center text-md-start border-start border-top border-end border-color-transparent-white-very-light">
                <div className="feature-box-content w-100 lg-mb-5 last-paragraph-no-margin">
                    <div className="text-white fs-22 alt-font fw-500 mb-20px">{title}</div>
                    {
                        presentations.map((presentation,idx) => {

                            return <div key={idx}>
                                <p className="text-white opacity-7">{presentation.topic} - {presentation.title} <br></br> {(presentation.presenters).map(presenter=>presenter.name).join(' , ')}<br/>
                                    {presentation.from ? new Date(presentation.from).toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' }) + '-tól ' : ''}
                                    {presentation.to ? new Date(presentation.to).toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' }) + '-ig' : ''}
                            </p>
                            {(idx<presentations.length-1) &&  <div className="divider-style-03 mb-20px divider-style-03-01 border-color-transparent-white-very-light">
                            </div> }
                            </div>
                        })
                    }
                    <span
                        className="number fs-120 ls-minus-5px fw-500 text-outline text-outline-width-2px text-outline-color-red opacity-7 alt-font position-absolute bottom-minus-50px sm-bottom-minus-40px left-0px ps-20 sm-ps-0 sm-right-0px sm-left-0px">{"0" + (idx + 1)}</span>
                </div>
                <div className="feature-box-overlay bg-red"></div>
            </div>
            <section
                style={{height:'40px', color:'#717580'}}
                className="p-0 bg-grey border-color-transparent-white-very-light background-position-left-bottom background-no-repeat overflow-hidden">

            </section>
        </div>
    )
}

export function EventHeaderBox({title,description}){

    return(
        <div className="col-xl-3 p-0">
            <div
                className="ps-20 pe-20 pt-25 pb-25 xxl-ps-15 xxl-pe-15 lg-p-7 sm-p-40px overflow-hidden h-100 text-center text-xl-start border-top border-end border-color-transparent-white-very-light">
                <h2 className="alt-font pt-25 fw-500 text-white ls-minus-2px">
                    { title }
                </h2>
                <p className="text-white opacity-7 mb-35px lg-w-50 md-w-70 sm-w-100 mx-auto mx-xl-auto">{description}</p>
            </div>
        </div>
    )
}

export function DetailedEvents({title,description,events}) {

    var invidualEvents=events[0];
    var teamEvents=events[1];

    const tabs = [events[0].title,events[1].title];

    return (
        <section>
            <div className="container">
                <div className="row justify-content-center mb-3 lg-mb-50px sm-mb-30px">
                    <div className="col-xl-6 text-center">
                        <h2 className="alt-font fw-700 ls-minus-2px text-dark-gray mb-15px">{title}</h2>
                        <p className="mb-0">{description}</p>
                    </div>
                </div>
                <div className="row g-0 mb-5 sm-mb-30px">
                    <div className="col event-style-03 bg-white box-shadow-quadruple-large">
                        <ul className="nav nav-tabs flex-wrap flex-md-nowrap fs-17 md-fs-15 fw-500 alt-font text-center bg-dark-gray border-color-white"
                            role="tablist">
                            {tabs.map((tab, tabidx) => (
                                <li key={tabidx} className="nav-item" role="presentation">
                                    <a className={`nav-link ${tabidx === 0 ? "active" : ""}`} data-bs-toggle="tab"
                                       href={`#tab_${tabidx}`} aria-selected={tabidx === 0 ? "true" : "false"} role="tab">
                                        {tab.toUpperCase()}
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div className="tab-content ps-65px pe-65px pt-45px pb-45px sm-p-30px xs-p-20px">
                                <div className={`tab-pane fade show active`}
                                     id={`tab_0`} role="tabpanel">
                                    <div className={`accordion accordion-style-00`}
                                         data-active-icon="fa-angle-up" data-inactive-icon="fa-angle-down">
                                        {
                                            invidualEvents.presentations.map((event, eventIdx) => {
                                                return <DetailedEventBox key={`0-${eventIdx}`} parentPanelId={0}
                                                                  idx={eventIdx} event={event}/>
                                            })
                                        }
                                    </div>
                                </div>
                                <div className={`tab-pane fade`}
                                     id={`tab_1`} role="tabpanel">
                                    <div className={`accordion accordion-style-00`}
                                         data-active-icon="fa-angle-up" data-inactive-icon="fa-angle-down">
                                        {
                                            teamEvents.presentations.map((event, eventIdx) => {
                                                return <DetailedEventBox key={`1-${eventIdx}`} parentPanelId={1}
                                                                         idx={eventIdx} event={event} overflow={false}/>
                                            })
                                        }
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center align-items-center">
                    <div className="col-auto text-center">
                    </div>
                </div>
            </div>
        </section>
    );
}

export function DetailedEventBox({ parentPanelId, idx, event,overflow=true }) {
    const panelId = `accordion-style-${parentPanelId}`;
    const itemId = `${panelId}-${idx}`;
    function capitalizeFirst(str) {
        if (!str) return ''; // ha üres vagy null, térjünk vissza üres stringgel
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }


    return (
        <div className="accordion-item">
            <div className="accordion-header event-header-bar">
                <a href="#" data-bs-toggle="collapse"
                   data-bs-target={`#${itemId}`} aria-expanded={"true"}
                   data-bs-parent={`#${panelId}`}>
                    <div className="ms-2 me-2 accordion-title position-relative alt-font fw-600 text-dark-gray d-flex flex-column align-items-start flex-sm-row align-items-sm-center mb-0">
                        <span className="event-time"><i className="feather icon-feather-clock me-5px"></i>
                            {event.from ? new Date(event.from).toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit'})+" - " : ''}
                            {event.to ? new Date(event.to).toLocaleTimeString('hu-HU', { hour: '2-digit', minute: '2-digit' }): ''}</span>
                        <span className="fs-18">{event.title}</span> <i className={"fa-solid fa-angle-up"}></i>
                    </div>
                </a>
            </div>
            <div id={itemId} className={`accordion-collapse collapse ${"show"}`}
                 data-bs-parent={`#${panelId}`}>
                <div className="accordion-body d-flex align-items-start align-items-lg-center flex-column flex-lg-row">
                    <div className={"trainer-box col-auto position-relative " + (event.presenters.some(presenter => (presenter.role===''))?'m-auto':'') }>
                        {event.presenters.map((presenter,idx)=> {
                            var badge=null;
                            if(presenter.awards){
                                var badges=JSON.parse(presenter.awards);
                                if(badges.length>0) {
                                    badge = badges[0];
                                }
                            }
                            var thumbUrl = normalizeImgUrlToThumb(presenter.imgUrl);

                            return <a key={idx} {...(presenter.role!=='' ? {href: "eloado/"+presenter.id} : {})}>
                                <div className="position-relative">
                                    { badge && <span
                                        className="border-radius-26px d-inline-block fs-12 fw-600 lh-24 px-3 py-1 text-white z-index-1"
                                        style={{
                                            position: 'absolute',
                                            top: '-30px',
                                            right: '-25px',
                                            backgroundImage: 'linear-gradient(to right, #1783e6, #acc557)'
                                        }}>
                                      <i className="fa-solid fa-trophy"></i> {badge.tag}
                                    </span>}
                                    <div className=" mt-5 d-flex overflow-hidden border-radius-6px border box-shadow-quadruple-large border-color-extra-medium-gray">
                                        <div className={"col-auto w-90px cover-background"}
                                             style={{ backgroundImage: `url(${thumbUrl ?? 'https://placehold.co/200x200'})` }}></div>
                                        <div className={"col bg-white position-relative p-25px"}>
                                            <span className="text-dark-gray fw-700 d-block lh-1 mb-4">{presenter.name}</span>
                                            <span className="text-dark-gray fw-400 d-block lh-1 mb-4">{presenter.companyName}</span>
                                            <span className="fs-15 lh-20 d-block">{capitalizeFirst(presenter.role)}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        })
                        }
                    </div>
                    <ExpandableParagraph text={event.description} overflow={overflow} />
                </div>
            </div>
        </div>
    );
}

export function ExpandableParagraph({ text,overflow}){
    const [expanded, setExpanded] = useState(false); // Csak erre az egy példányra vonatkozik
    const [isOverflowing, setIsOverflowing] = useState(false); // Kell-e "...Olvass tovább"
    const paragraphRef = useRef(null);

    useEffect(() => {
        const el = paragraphRef.current;
        if (el && overflow) {
            const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
            const maxHeight = lineHeight * 3;
            setIsOverflowing(el.scrollHeight > maxHeight);
        }
        else{
            setExpanded(true);
        }
    }, [text]);

    return (
        <div className="expandable-wrapper">
            <p
                ref={paragraphRef}
                className={`description-paragraph ${expanded ? "expanded" : "clamped"}`}
            >
                {text}
            </p>
            {isOverflowing && (
                <div className="read-more-container">
                    <button
                        className="read-more-btn"
                        style={{color:'black'}}
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Kevesebb" : "mutass többet"}
                    </button>
                </div>
            )}
        </div>
    );
};
